module.exports = __webpack_public_path__ + "static/media/avatar.364867f3.png";